import React, { useState } from 'react';
import { Play } from 'lucide-react';

// Shared lightweight YouTube facade used by the VSL + video testimonials.
// Shows the poster + branded play button and only loads the real embed (with sound)
// AFTER a user click, never autoplays with sound on initial page load.
// `size` controls the play-button scale ('lg' for the main VSL, 'md' for testimonials).
export default function YouTubeLite({ videoId, title, size = 'md' }) {
  const [playing, setPlaying] = useState(false);
  const [poster, setPoster] = useState(`https://i.ytimg.com/vi/${videoId}/maxresdefault.jpg`);

  if (playing) {
    return (
      <iframe
        className="absolute inset-0 h-full w-full"
        src={`https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0&modestbranding=1&playsinline=1`}
        title={title}
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      />
    );
  }

  const btn =
    size === 'lg'
      ? 'h-24 w-24 md:h-28 md:w-28'
      : 'h-[72px] w-[72px]';
  const icon = size === 'lg' ? 40 : 28;

  return (
    <button
      type="button"
      onClick={() => setPlaying(true)}
      aria-label={`Play ${title}`}
      className="group absolute inset-0 h-full w-full cursor-pointer overflow-hidden bg-[var(--ob-dark)]"
    >
      <img
        src={poster}
        onError={() => setPoster(`https://i.ytimg.com/vi/${videoId}/hqdefault.jpg`)}
        alt={title}
        loading="lazy"
        className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
      />
      <span className="absolute inset-0 bg-black/30 transition-colors duration-300 group-hover:bg-black/15" />
      <span
        className={`absolute left-1/2 top-1/2 flex ${btn} -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full bg-[var(--ob-accent)] text-[var(--ob-dark)] shadow-xl transition-transform duration-300 group-hover:scale-110`}
      >
        <Play size={icon} className="ml-1 fill-current" />
      </span>
    </button>
  );
}
